type Props = {
  children: string;
};

export const AuthTitle = ({ children }: Props) => (
  <p className="md:text-left text-center text-xxl text-color-medium-grey font-cabin-regular">
    {children}
  </p>
);
